import React, { Component } from 'react'
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown'

import CrossSmallIcon from '../../../assets/icons/cross.svg'


class CustomDropdown extends Component {
    constructor(props) {
        super(props);
        this.dropdownRef = React.createRef()
    }

    render() {
        return (
            <Dropdown disabled={this.props.disabled}
                      className={"dropdown-right dropdown-caret" + this.props.additionalClasses ? this.props.additionalClasses : ""}
                ref={this.dropdownRef}>
                <DropdownTrigger className={"button-icontrigger caption" + (this.props.disabled ? ' button-icontrigger-disabled':'')}>
                    <span className="icon">
                        {this.props.children}
                    </span>
                    <span>{this.props.triggerText}</span>
                </DropdownTrigger>
                <DropdownContent>
                    <div className={`dropdown-content caret ${this.props.additionalClasses}`}>
                        <div className={`dropdown-content-data ${this.props.additionalClasses ?
                            this.props.additionalClasses + "-" + this.props.additionalClasses : ""}`}>
                            <p>{this.props.headText}</p>
                        </div>
                        <div className="dropdown-content-actions">
                            {!this.props.hideButton && <div className="dropdown-content-actions-left">
                                <button className="button" onClick={() => {
                                    if (this.props.props && this.props.onAction) {
                                        this.dropdownRef.current.hide()
                                        this.props.onAction(this.props.props)
                                    } else {
                                        if (this.props.onAction) {
                                            this.dropdownRef.current.hide()
                                            this.props.onAction()
                                        }
                                    }
                                }}>
                                    <span>
                                        {this.props.buttonText}
                                    </span>
                                </button>
                            </div>}
                            <div className="dropdown-content-actions-right">
                                <button className="button-icontrigger noborder"
                                    onClick={() => {
                                        this.dropdownRef.current.hide()
                                    }}>
                                    <span className="icon">
                                        <CrossSmallIcon />
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </DropdownContent>
            </Dropdown>
        )
    }
}

export default CustomDropdown
